import "bootstrap/dist/css/bootstrap.css";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./localization/i18n";
import { unregister } from "./registerServiceWorker";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

const root = ReactDOM.createRoot(rootElement);
root.render(
  <Suspense fallback="...is loading">
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>
  </Suspense>
);

unregister();
